<div class='row'>
  @if (applicant?.pesel; as pesel) {
    <div class="col-md-4">
      <app-label label='Numer PESEL:'>
        {{ pesel || '-' }}
      </app-label>
    </div>
  }
  @if (applicant?.nip; as nip) {
    <div class="col-md-4">
      <app-label label='Numer NIP:'>
        {{ nip || '-' }}
      </app-label>
    </div>
  }
  <div class='col-md-4'>
    <app-label label='Numer telefonu:'>
      {{ applicant?.phoneNumber || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Numer telefonu2:'>
      {{ applicant?.phoneNumber2 || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='E-mail:'>
      {{ applicant?.email || '-' }}
    </app-label>
  </div>
  @if (isNaturalPerson()) {
    <div class="col-md-4">
      <app-label label="Kraj:">
        {{ applicant?.country || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Województwo:">
        {{ applicant?.voivodeship || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Powiat:">
        {{ applicant?.county || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Gmina:">
        {{ applicant?.municipality || '-' }}
      </app-label>
    </div>
  }
  <div class='col-md-4'>
    <app-label label='Kod pocztowy:'>
      {{ applicant?.postalCode || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Poczta:'>
      {{ applicant?.postOffice || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Miejscowość:'>
      {{ applicant?.city || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Ulica:'>
      {{ applicant?.street || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Nr domu:'>
      {{ applicant?.houseNumber || '-' }}
    </app-label>
    @if (applicant?.apartmentNumber; as apartmentNumber) {
      &nbsp;
      <app-label label='Nr mieszkania:'>
        {{ applicant?.apartmentNumber || '-' }}
      </app-label>
    }
  </div>
  @if (applicant?.differentCorrespondenceAddress) {
    <div class="col-12">
      <p class="mt-3 mb-2">
        <strong>
          Dane do korespondencji
        </strong>
      </p>
    </div>
    @if (isNaturalPerson()) {
      <div class="col-md-4">
        <app-label label="Kraj:">
          {{ applicant?.correspondenceCountry || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Województwo:">
          {{ applicant?.correspondenceVoivodeship || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Powiat:">
          {{ applicant?.correspondenceCounty || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Gmina:">
          {{ applicant?.correspondenceMunicipality || '-' }}
        </app-label>
      </div>
    }
    <div class='col-md-4'>
      <app-label label='Kod pocztowy:'>
        {{ applicant?.correspondencePostalCode || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Poczta:'>
        {{ applicant?.correspondencePostOffice || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Miejscowość:'>
        {{ applicant?.correspondenceCity || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Ulica:'>
        {{ applicant?.correspondenceStreet || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr domu:'>
        {{ applicant?.correspondenceHouseNumber || '-' }}
      </app-label>
      @if (applicant?.correspondenceApartmentNumber; as apartmentNumber) {
        &nbsp;
        <app-label label='Nr mieszkania:'>
          {{ apartmentNumber || '-' }}
        </app-label>
      }
    </div>
  }
</div>


